'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAllow$002dPayload from "./presto.types$-Allow-Payload.js";
var $p;
/** @constructor */
function $c_Lpresto_types$AllowPayload$() {
}
export { $c_Lpresto_types$AllowPayload$ as $c_Lpresto_types$AllowPayload$ };
$p = $c_Lpresto_types$AllowPayload$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$AllowPayload$;
/** @constructor */
function $h_Lpresto_types$AllowPayload$() {
}
export { $h_Lpresto_types$AllowPayload$ as $h_Lpresto_types$AllowPayload$ };
$h_Lpresto_types$AllowPayload$.prototype = $p;
$p.l = (function() {
  return "AllowPayload";
});
$p.cGn = (function(x$0) {
  return new $j_presto$002etypes$0024$002dAllow$002dPayload.$c_Lpresto_types$AllowPayload(x$0.j(0));
});
var $d_Lpresto_types$AllowPayload$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$AllowPayload$, "presto.types$AllowPayload$", ({
  Yu: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$AllowPayload$ as $d_Lpresto_types$AllowPayload$ };
var $n_Lpresto_types$AllowPayload$;
function $m_Lpresto_types$AllowPayload$() {
  if ((!$n_Lpresto_types$AllowPayload$)) {
    $n_Lpresto_types$AllowPayload$ = new $c_Lpresto_types$AllowPayload$();
  }
  return $n_Lpresto_types$AllowPayload$;
}
export { $m_Lpresto_types$AllowPayload$ as $m_Lpresto_types$AllowPayload$ };
//# sourceMappingURL=presto.types$-Allow-Payload$.js.map
